import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/whatsapp.png'
import _imports_1 from '../../../assets/img/icons/download.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card shadow-lg" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "details-title list-style mb-40" }
const _hoisted_7 = { class: "fs-14 fw-semibold text-title lh-1" }
const _hoisted_8 = { class: "text-optional ms-1" }
const _hoisted_9 = { class: "fs-14 fw-semibold text-title lh-1" }
const _hoisted_10 = { class: "text-optional ms-1" }
const _hoisted_11 = { class: "fs-14 fw-semibold text-title lh-1" }
const _hoisted_12 = { class: "text-optional ms-1" }
const _hoisted_13 = { class: "fs-14 fw-semibold text-title lh-1" }
const _hoisted_14 = { class: "badge badge-outline-green fw-semibold ms-1 fs-14" }
const _hoisted_15 = { class: "fs-14 fw-semibold text-title lh-1" }
const _hoisted_16 = { class: "badge badge-outline-green fw-semibold ms-1 fs-14" }
const _hoisted_17 = { class: "table-responsive style-two" }
const _hoisted_18 = { class: "table text-nowrap align-middle mb-0 border-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_20 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_22 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_23 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_24 = { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph float-right" }
const _hoisted_25 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_26 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_27 = { class: "shadow-none lh-1 fs-14 fw-black text-purple" }
const _hoisted_28 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }

import { SalesMetadataAndProductResponseDTO } from "@/interfaces/interfaces/salesInterface";
  import { ref, Ref, watch } from "vue";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SaleDetailsTemp',
  props: {
    saleDetails: {}
  },
  setup(__props: any) {

  const props = __props;
  const defaultSale: SalesMetadataAndProductResponseDTO = {
    id: '',
    transactionDate: '',
    status: '',
    totalAmount: 0,
    paymentType: '',
    paymentCustomerName: '',
    paymentTypeTransactionId: '',
    sellerFullName: '',
    discount : 0,
    shippingCost : 0,
    shippingAddress : 'N/A',
    orderTaxPercentage : 0,
    productSales: []
};
const selectedSale = ref<SalesMetadataAndProductResponseDTO>(props.saleDetails || defaultSale);
  
  const printPage = () => {
    window.print();
  };
  watch(
  selectedSale,
  (newValue, oldValue) => {

  },
  { deep: true } // Enable deep watching for nested objects
);
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "fs-16 fw-bold text-title mb-20" }, "Invoice Details:", -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _cache[0] || (_cache[0] = _createTextVNode(" DATE :")),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.saleDetails?.transactionDate), 1)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _cache[1] || (_cache[1] = _createTextVNode(" REFERENCE :")),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.saleDetails?.id), 1)
              ]),
              _createElementVNode("li", _hoisted_11, [
                _cache[2] || (_cache[2] = _createTextVNode(" SELLER :")),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.saleDetails?.sellerFullName), 1)
              ]),
              _createElementVNode("li", _hoisted_13, [
                _cache[3] || (_cache[3] = _createTextVNode(" PAYMENT METHOD :")),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.saleDetails?.paymentType), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _cache[4] || (_cache[4] = _createTextVNode(" PAYMENT STATUS :")),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.saleDetails?.status), 1)
              ])
            ])
          ]),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"col-lg-6 ps-xxl-6\"><h6 class=\"fs-16 fw-bold text-title mb-20\">Company info:</h6><ul class=\"details-title list-style mb-40\"><li class=\"fs-14 fw-semibold text-title lh-1\"> NAME :<span class=\"ms-1 text-optional\">AuraBe</span></li><li class=\"fs-14 fw-semibold text-title lh-1\"> MAIL :<span class=\"text-optional ms-1\">aurabegroup@kode.com</span></li><li class=\"fs-14 fw-semibold text-title lh-1\"> PHONE :<span class=\"text-optional ms-1\">+509 3718 0660</span></li><li class=\"fs-14 fw-semibold text-title lh-1\"> ADDRESS :<span class=\"text-optional ms-1\">#4 Portail Bainet, Jacmel,Sud-Est, Haiti</span></li></ul></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg_mild" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " NO. "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " PRODUCT "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " CODE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " UNIT PRICE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " QUANTITY "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " DISCOUNT "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " TAX "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 lh-1 bg_mild"
                }, " SUBTOTAL ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleDetails?.productSales, (product) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "br-s-1",
                  key: product?.productCode
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph br-s-1" }, " 01. ", -1)),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(product.productName), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(product.productCode), 1),
                  _createElementVNode("td", _hoisted_21, " HTG " + _toDisplayString(product.unitCost), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(product.quantity), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }, " HTG 0.00 ", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }, " HTG 0.00 ", -1)),
                  _createElementVNode("td", _hoisted_23, " HTG " + _toDisplayString((product.quantity * product.unitCost).toFixed(2)), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-title float-right br-s-1" }, " ORDER TAX ", -1)),
                _createElementVNode("td", _hoisted_24, " HTG " + _toDisplayString(_ctx.saleDetails?.orderTaxPercentage), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-title float-right br-s-1" }, " DISCOUNT ", -1)),
                _createElementVNode("td", _hoisted_25, " HTG " + _toDisplayString(_ctx.saleDetails?.discount), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[25] || (_cache[25] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[26] || (_cache[26] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-title float-right br-s-1" }, " Shipping ", -1)),
                _createElementVNode("td", _hoisted_26, " HTG " + _toDisplayString(_ctx.saleDetails?.shippingCost), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[31] || (_cache[31] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[32] || (_cache[32] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[33] || (_cache[33] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[34] || (_cache[34] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[35] || (_cache[35] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[36] || (_cache[36] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[37] || (_cache[37] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-title br-s-1" }, " GRAND TOTAL ", -1)),
                _createElementVNode("td", _hoisted_27, " HTG " + _toDisplayString(_ctx.saleDetails?.totalAmount), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[38] || (_cache[38] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[40] || (_cache[40] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[41] || (_cache[41] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[42] || (_cache[42] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[43] || (_cache[43] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }, null, -1)),
                _cache[44] || (_cache[44] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-title float-right br-s-1" }, " PAID ", -1)),
                _createElementVNode("td", _hoisted_28, " HTG " + _toDisplayString(_ctx.saleDetails?.totalAmount), 1)
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph border-0" }),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-title float-right br-s-1 br-1" }, " DUE "),
                _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-semibold text-paragraph br-1" }, " HTG 0.00 ")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "pt-25 pb-35 d-flex flex-wrap justify-content-end me-xxl-3" }, [
      _createElementVNode("a", {
        href: "../../../assets/img/products.pdf",
        class: "btn style-eight me-2"
      }, [
        _createTextVNode(" Whatsapp "),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Image"
        })
      ]),
      _createElementVNode("a", {
        class: "btn style-five upload-btn px-xxl-6",
        onclick: "window.print();"
      }, [
        _createTextVNode(" Print "),
        _createElementVNode("img", {
          src: _imports_1,
          alt: "Image"
        })
      ])
    ], -1))
  ]))
}
}

})